import React, { useEffect, lazy, Suspense } from 'react';
import '../../styles/styles.css';
import '../../styles/custom-fixes.css';
import { useThemeMode } from '../../ThemeContext';
import SiteHeader from '../../components/SiteHeader';
import DemoTrail from './DemoTrail';
import ComplianceInfo from './ComplianceInfo';
import CompleteWHSCompliance from './CompleteWHSCompliance';

const HowItWorks = lazy(() => import('./HowItWorks'));
const MobileApps = lazy(() => import('./MobileApps'));
const PlanDetails = lazy(() => import('./PlanDetails'));
const ComplianceTeams = lazy(() => import('./ComplianceTeams'));
const FAQ = lazy(() => import('./FAQ'));
const Footer = lazy(() => import('./Footer'));

function Home() {
  const { mode } = useThemeMode();

  useEffect(() => {
    document.body.classList.remove('dark-mode', 'light-mode');
    document.body.classList.add(mode === 'dark' ? 'dark-mode' : 'light-mode');
  }, [mode]);

  return (
    <div style={{ backgroundColor: mode === 'dark' ? '#111' : '#fff', minHeight: '100vh' }}>
      <SiteHeader />
      <DemoTrail />
      <ComplianceInfo />
      <CompleteWHSCompliance />
      <Suspense fallback={null}>
        <HowItWorks />
        <MobileApps />
        <PlanDetails />
        <ComplianceTeams />
        <FAQ />
        <Footer />
      </Suspense>
    </div>
  );
}

export default Home;
